'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var nthHookSettings = require('@narvar/nth-hook-settings');
var Star = require('@narvar/nth-bit-icon-star');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var StarRating_module = require('./StarRating.module.css.js');
var index = require('./components/RatingText/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var Star__default = /*#__PURE__*/_interopDefaultLegacy(Star);

const StarRating = ({
  onClick,
  onKeyDown,
  selectedRating,
  featureName,
  isLandscape = false,
  displayTextFirst = false
}) => {
  const {
    feedback
  } = nthHookSettings.useSettings();
  const {
    enableStarRatingText: enableStarRatingTextIn
  } = feedback || {};
  const enableStarRatingText = typeof enableStarRatingTextIn === 'boolean' ? enableStarRatingTextIn : true;
  const {
    feedbackRatingShortOne,
    feedbackRatingShortTwo,
    feedbackRatingShortThree,
    feedbackRatingShortFour,
    feedbackRatingShortFive,
    feedbackRatingSubcaption
  } = nthHookTranslations.useTranslations();
  const [hovered, setHovered] = React.useState(false);
  const [hoverRating, setHoverRating] = React.useState(0);
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const ratingText = [feedbackRatingShortOne || '', feedbackRatingShortTwo || '', feedbackRatingShortThree || '', feedbackRatingShortFour || '', feedbackRatingShortFive || ''];
  const handleClick = submittedRating => {
    logEvent({
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.RATING,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.RATING,
      clickSurveyRating: submittedRating,
      clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_STAR_RATING,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_STAR_RATING,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_STAR_RATING
    });
    if (onClick) {
      onClick(submittedRating, `${feedbackRatingSubcaption || ''} ${ratingText[submittedRating - 1].toLowerCase()}?`);
    }
  };
  const ratingNumber = hovered ? hoverRating : selectedRating;
  const stars = /*#__PURE__*/React__default["default"].createElement("div", {
    className: StarRating_module["default"].fieldSetContainer
  }, /*#__PURE__*/React__default["default"].createElement("fieldset", {
    className: StarRating_module["default"].styledFieldset
  }, [...Array(5)].map((_, index) => /*#__PURE__*/React__default["default"].createElement("span", {
    key: `star-rating-${index + 1}`
  }, /*#__PURE__*/React__default["default"].createElement("input", {
    className: StarRating_module["default"].visuallyHiddenInput,
    type: "radio",
    id: `rating-star-${index + 1}`,
    name: "starRating",
    value: index + 1,
    onFocus: () => {
      setHovered(true);
      setHoverRating(index + 1);
    },
    onBlur: () => {
      setHovered(false);
      setHoverRating(0);
    },
    onKeyDown: e => {
      if (!onKeyDown) return;
      onKeyDown(e, index + 1, `${feedbackRatingSubcaption || ''} ${ratingText[index].toLowerCase()}?`);
    },
    onClick: () => {
      handleClick(index + 1);
    },
    "aria-label": ratingText[index],
    "data-test": `starRatingIconButton${index + 1}`
  }), /*#__PURE__*/React__default["default"].createElement("label", {
    className: StarRating_module["default"].inputLabel,
    htmlFor: `rating-star-${index + 1}`,
    onMouseEnter: () => {
      setHovered(true);
      setHoverRating(index + 1);
    },
    onMouseLeave: () => {
      setHovered(false);
      setHoverRating(0);
    }
  }, /*#__PURE__*/React__default["default"].createElement(Star__default["default"], {
    featureName: featureName,
    full: hovered ? hoverRating >= index + 1 : selectedRating >= index + 1,
    s: {
      width: 'calc(100% - 0.5rem)',
      margin: '0 auto',
      height: '2rem'
    },
    "data-test": `starRatingIconStar${index + 1}`
  }))))));
  const text = /*#__PURE__*/React__default["default"].createElement(index["default"], {
    ratingText: ratingText,
    ratingNumber: ratingNumber,
    selectedRating: selectedRating,
    isLandscape: isLandscape,
    feedbackRatingSubcaption: feedbackRatingSubcaption || '',
    featureName: featureName
  });
  const starsClasses = clsx__default["default"]({
    [StarRating_module["default"].stars]: true,
    [StarRating_module["default"].textFirst]: displayTextFirst
  });
  if (isLandscape) {
    const starsAndText = [/*#__PURE__*/React__default["default"].createElement("div", {
      key: "stars",
      className: StarRating_module["default"].stars
    }, stars), /*#__PURE__*/React__default["default"].createElement(React.Fragment, {
      key: "text"
    }, enableStarRatingText && /*#__PURE__*/React__default["default"].createElement("div", {
      className: starsClasses
    }, text))];
    if (displayTextFirst) starsAndText.reverse();
    return /*#__PURE__*/React__default["default"].createElement("div", null, starsAndText);
  }
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: StarRating_module["default"].center
  }, stars, enableStarRatingText && /*#__PURE__*/React__default["default"].createElement("div", {
    className: StarRating_module["default"].ratingText
  }, text));
};
var StarRating$1 = nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(StarRating, {
  translationKeys: ['feedbackRatingShortOne', 'feedbackRatingShortTwo', 'feedbackRatingShortThree', 'feedbackRatingShortFour', 'feedbackRatingShortFive', 'feedbackRatingSubcaption']
}), {
  settingsRequested: `
      feedback {
        enableStarRatingText
      }
    `
});

exports["default"] = StarRating$1;
